import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import Loading from 'components/Loading';
import Image from 'components/Image';
import QualityValue from 'components/QualityValue';

function PlayerEchoes(props) {
  return (
    <li className="item">
      <Link to="/bazaar" className="icon icon--currency">
        <Image
          className="media__object"
          icon="echoes"
          type="currencies"
          width={60}
          height={78}
        />
      </Link>
      <div className="item__desc">
        <span className="js-item-name item__name">Echoes</span>
        <Value {...props} />
      </div>
    </li>
  );
}

PlayerEchoes.displayName = 'PlayerEchoes';

function Value({ isFetching, pennies }) {
  if (isFetching) {
    return (
      <div>
        {' '}
        <Loading spinner small />
      </div>
    );
  }
  return <div className="invert"><QualityValue value={pennies} isCurrency /></div>;
}

Value.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  pennies: PropTypes.number.isRequired,
};

const mapStateToProps = ({ myself: { isFetching, qualities } }) => {
  if (isFetching) {
    return { isFetching, pennies: 0 };
  }

  const pennyQuality = qualities.find(({ name }) => name === 'Penny');
  if (!pennyQuality) {
    return { isFetching, pennies: 0 };
  }
  return { isFetching, pennies: pennyQuality.level };
};

export default withRouter((connect(mapStateToProps)(PlayerEchoes)));